export const ethereumTxHashRegex = /^0x([A-Fa-f0-9]{64})$/;

export const cosmosTxHashRegex = /^[0-9A-Fa-f]{64}/;

export const getCosmosAddressRegex = (prefix: string, lengths: number[]) =>
  new RegExp(`^${prefix}(${lengths.map((item) => `(.{${item},${item}})`).join('|')})$`);
